import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-html-notes',
    templateUrl: './html-notes.component.html',
    styleUrls: ['./html-notes.component.scss'],
    standalone: false
})
export class WidgetHtmlNotesComponent implements OnInit, OnDestroy {
  static key = 100202

  @Input('config') config:any = {}
  @Input('item') item:any
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>();
  @ViewChild('htmlDiv', { static: true }) htmlDiv!: ElementRef;

  private observer?: ResizeObserver

  constructor() { }

  ngOnInit(): void {
    // Auto Height
    this.observer = new ResizeObserver((e: ResizeObserverEntry[]) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    this.observer.observe(this.htmlDiv.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect()
  }

}
